import { Button, Group, Stack, Title } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

import { IconPlus } from "@tabler/icons-react";

import NotFound from "@/NotFound";
import PermissionGate from "@/permission/components/PermissionGate";
import { PROVIDER_SCRIBE_READER_PERMISSION_FLAGS } from "@/permission/constants/practitioner-permissions";

import { ChecklistTemplateDrawer } from "./components";
import ChecklistTemplateTable from "./components/ChecklistTemplateTable";

function ChecklistTemplates() {
  const [isTemplateDrawerOpen, { open: openTemplateDrawer, close: closeTemplateDrawer }] =
    useDisclosure(false);

  return (
    <PermissionGate
      fallback={<NotFound />}
      requiredPermissions={PROVIDER_SCRIBE_READER_PERMISSION_FLAGS}
    >
      <ChecklistTemplateDrawer opened={isTemplateDrawerOpen} onClose={closeTemplateDrawer} />
      <Stack gap="xs">
        <Group justify="space-between">
          <Title order={2}>Checklist Templates</Title>
          <Button onClick={openTemplateDrawer} leftSection={<IconPlus size={16} />}>
            New Template
          </Button>
        </Group>
        <ChecklistTemplateTable onOpenTemplateDrawer={openTemplateDrawer} />
      </Stack>
    </PermissionGate>
  );
}

export default ChecklistTemplates;
